
import filters from "~/mixins/filters";
import {mapActions, mapGetters} from "vuex";

export default {
	mixins: [filters],
	computed: {
		...mapGetters({
			offer: 'catalog/catalog-cars/offer',
			likesArray: 'favorite/favorite/likesArray',
		})
	},
	methods: {
		...mapActions({
			liked: 'favorite/favorite/liked',
			openModal: 'modal/modal-main/openModal',
			request: 'request'
		}),
		async like() {
			await this.liked(this.offer.external_id)
		},
		// creditClick(carInfo) {
		// 	let payload = {
		// 		modal_data: carInfo,
		// 		modal_component: 'modal-credit',
		// 		modal_title: 'Заявка на автокредит',
		// 		modal_sub_title: carInfo.name
		// 	}
		// 	this.openModal(payload)
		// },
			tradeInClick(carInfo) {
			let payload = {
				modal_data: carInfo,
				modal_component: 'modal-tradeIn',
				modal_title: 'Заявка на Trade-In',
				modal_sub_title: carInfo.name
			}
			this.openModal(payload)
		},
        callback() {
			let payload = {
				modal_data: this.offer,
				modal_component: 'modal-callback',
				modal_title: 'Обратный звонок',
				modal_sub_title: this.offer.name
			}
			this.openModal(payload)
		},
		async autoteka(carInfo) {
			let payload = {
				modal_data: carInfo,
				modal_component: 'modal-autoteka',
				modal_title: 'Отчет по акутальным базам РФ от ' + carInfo.createdAt,
				modal_sub_title: carInfo.name
			}
			await this.openModal(payload)
		},
	}
}
